import React, { useState, useEffect, useRef } from "react";
import { FaEllipsisV } from "react-icons/fa";
import "./header.css";
import { Avatar, notification } from "antd";
import NotificationIcon from "../../Assets/Icons/notification-bing.png";
import Profile from "../../Assets/Icons/Profile.png";
import Widgets from "../../widgets";
import authService from "../../services/authService";
import Icons from "../../Assets/Icons";
import { useMsal } from "@azure/msal-react";
import environment from "../../utils/environment";
import { getToken } from "firebase/messaging";
import strings from "../../utils/strings";
import { useSelector, useDispatch } from "react-redux";
import { postFcmToken, getAllNotification, readNotification, delFcmToken, getAdminPrivilege } from "../../modules/notification/notificationThunk";
import ToastPopup from "../../widgets/Toast/toastPopup";
import { messaging } from "../../firebase/firebase";
import { resetFcmToken, resetGetAllNotification, resetGetAdminPrivilege } from "../../modules/notification/notificationSlice";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { onMessage } from "firebase/messaging";
import { setPrivilege } from "../../modules/status/verificationType";

const Header = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { instance } = useMsal();
  const [showMenu, setShowMenu] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);
  const [note, setNote] = useState({});
  const [showNotification, setShowNotification] = useState(false);
  const [logoutPopup, setLogoutPopup] = useState(false);
  const modalRef = useRef(null);
  const logoutRef = useRef(null);
  const { fcmTokenSuccess, fcmTokenErr, allNotificationSuccess, allNotificationErr, readNotificationSuccess, readNotificationErr, getAdminPrivilegeSuccess, getAdminPrivilegeErr } = useSelector(
    (state) => state.notification,
  );
  const privilege = useSelector((state) => state.verifyType.privilege);

  const [page, setPage] = useState(1);
  const [readId, setReadId] = useState("");
  const limit = 10;
  const [hasMore, setHasMore] = useState(true);
  const [loadedPages, setLoadedPages] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (getAdminPrivilegeErr) {
      ToastPopup.error(getAdminPrivilegeErr);
    }
    if (getAdminPrivilegeSuccess && getAdminPrivilegeSuccess.status === "success") {
      authService.setPrivilege(getAdminPrivilegeSuccess.data);
      dispatch(setPrivilege(getAdminPrivilegeSuccess.data));
    }
    dispatch(resetGetAdminPrivilege());
  }, [getAdminPrivilegeSuccess, getAdminPrivilegeErr]);

  useEffect(() => {
    dispatch(getAdminPrivilege());
  }, []);

  const callNotification = (page) => {
    dispatch(getAllNotification({ page, limit }));
  };

  useEffect(() => {
    Notification.requestPermission();
    onMessage(messaging, (payload) => {
      handlePageReload(1);
      const notificationTitle = payload.notification.title;
      const notificationOptions = {
        body: payload.notification.body,
      };
      new Notification(notificationTitle, notificationOptions).onclick = function () {
        if (document.visibilityState === "hidden") {
          window.focus();
        }
        handleChromeNotClick(payload.data);
      };
    });
  }, []);

  useEffect(() => {
    callNotification(page);
  }, [page]);

  useEffect(() => {
    if (readNotificationErr) {
      ToastPopup.error(readNotificationErr);
    }

    if (readNotificationSuccess && readNotificationSuccess.status === "success") {
      const pageToReload = Object.keys(loadedPages).find((page) => loadedPages[page].includes(readId));

      if (pageToReload) {
        handlePageReload(Number(pageToReload));
      }
    }

    dispatch(resetGetAllNotification());
  }, [readNotificationSuccess, readNotificationErr]);

  useEffect(() => {
    if (allNotificationErr) {
      ToastPopup.error(allNotificationErr);
    }

    if (allNotificationSuccess && allNotificationSuccess.status === "success") {
      const newNotifications = allNotificationSuccess.data.notifications;

      setNotificationCount(allNotificationSuccess.data.totalUnreadCount);
      setNotifications((prevNotifications) => {
        const prevArray = Array.isArray(prevNotifications) ? prevNotifications : [];
        const updatedNotifications = prevArray.map((notification) => {
          const updated = newNotifications.find((n) => n._id === notification._id);
          return updated ? { ...notification, isRead: updated.isRead } : notification;
        });
        const newOnlyNotifications = newNotifications.filter((newNotification) => !updatedNotifications.find((n) => n._id === newNotification._id));

        return [...updatedNotifications, ...newOnlyNotifications];
      });

      if (!loadedPages[page]) {
        setLoadedPages((prevPages) => ({
          ...prevPages,
          [page]: newNotifications.map((n) => n._id),
        }));
      }

      if (allNotificationSuccess.data.currentPage >= allNotificationSuccess.data.totalPages) {
        setHasMore(false);
      }
    }
    setLoading(false);
  }, [allNotificationSuccess, allNotificationErr]);

  const setUnreadCount = () => {
    const unreadNotifications = notifications.filter((notification) => !notification.isRead);
    // setNotificationCount(unreadNotifications.length);
  };

  useEffect(() => {
    setUnreadCount();
  }, [notifications]);

  const handleLoadMore = () => {
    setPage((prevPage) => prevPage + 1);
    setLoading(true);
  };
  const handlePageReload = (pageToReload) => {
    setLoadedPages((prevPages) => {
      const updatedPages = { ...prevPages };
      delete updatedPages[pageToReload];
      return updatedPages;
    });
    callNotification(pageToReload);
  };

  useEffect(() => {
    if (fcmTokenErr) {
      ToastPopup.error(fcmTokenErr);
    }
    if (fcmTokenSuccess && fcmTokenSuccess.status === "success") {
      localStorage.setItem(strings.fcmToken, fcmTokenSuccess.data.token.device.token);
      localStorage.setItem(strings.deviceId, fcmTokenSuccess.data.token.device.id);
    }
    dispatch(resetFcmToken());
  }, [fcmTokenSuccess, fcmTokenErr]);

  const sendFcmToken = (fcmToken) => {
    function generateUniqueId() {
      return `${Date.now()}-${Math.floor(Math.random() * 100000000000)}`;
    }
    const uniqueId = generateUniqueId();
    const LocalFcmId = localStorage.getItem(strings.deviceId);

    const body = {
      type: "WEB",
      name: LocalFcmId || uniqueId,
      id: LocalFcmId || uniqueId,
      token: fcmToken,
    };

    dispatch(postFcmToken({ body }));
  };

  useEffect(() => {
    const requestNotificationPermission = async () => {
      const permission = await Notification.requestPermission();

      if (permission === "granted") {
        try {
          const fcmToken = await getToken(messaging, {
            vapidKey: "BOhzQmz2wSvJTWYQ1BW8lWGB68bTYKnP0nFTkLZVjETbw3vf-oMbG9yVuazd9rfhzKUrkn2iKFvNM-sjZxM1Vps",
          });

          if (fcmToken) {
            const localFcmToken = localStorage.getItem(strings.fcmToken);
            if (fcmToken && fcmToken !== localFcmToken) {
              sendFcmToken(fcmToken);
            }
          }
        } catch (error) {
          console.error("Error getting FCM token:", error);
        }
      } else {
        console.error("Permission not granted for notifications.");
      }
    };

    requestNotificationPermission();

    setInterval(
      () => {
        requestNotificationPermission();
      },
      5 * 60 * 1000,
    );
  }, []);

  const handleLogout = () => {
    setLogoutPopup(true);
    setShowMenu(false);
  };

  const handleCancelDelete = () => {
    setLogoutPopup(false);
  };

  const adminName = authService.getAdminName();

  const handleConfirmDelete = () => {
    localStorage.removeItem(strings.refreshToken);
    authService.setPrivilege({})
    const localFcmToken = localStorage.getItem(strings.fcmToken);
    const body = {
      token: localFcmToken,
    };
    localStorage.removeItem(strings.fcmToken);
    dispatch(delFcmToken({ body }));
    signOutClickHandler(instance);
  };

  const signOutClickHandler = (instance) => {
    const accounts = instance.getAllAccounts();
    if (accounts.length > 0) {
      const homeAccountId = accounts[0].homeAccountId;

      const logoutRequest = {
        account: instance.getAccountByHomeId(homeAccountId),
        mainWindowRedirectUri: environment.redirectAzureUrl,
      };

      instance.logoutPopup(logoutRequest);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowNotification(false);
      }
      if (logoutRef.current && !logoutRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalRef, logoutRef]);

  useEffect(() => {
    setNote(groupNotificationsByDate(notifications));
  }, [notifications]);

  const getNotificationNavTarget = (navData) => {
    const type = navData?.type || "";
    const requestId = navData?.requestId || navData?.id || "";
    const sessionId = navData?.sessionId || "";
    const status = (navData?.status || "").toUpperCase();

    if (type === "ProfileVerificationRequestReceived") {
      return { path: strings.navigation.patientProfile, state: navData };
    }

    // Nursing care notifications — route to the correct tab
    if (type.toLowerCase().includes("nursing") || type.toLowerCase().includes("nurse") || type.toLowerCase().includes("session") || type.toLowerCase().includes("request")) {
      if (status === "CHECKED_OUT" || status === "COMPLETED") {
        const url = sessionId
          ? `${strings.navigation.viewSessionDetails}?id=${encodeURIComponent(sessionId)}&from=past`
          : `${strings.navigation.manageNurseReq}?activeList=past`;
        return { path: url };
      }
      if (status === "CONFIRMED" || status === "CHECKED_IN" || status === "ASSIGNED") {
        const url = sessionId
          ? `${strings.navigation.viewSessionDetails}?id=${encodeURIComponent(sessionId)}&from=upcoming`
          : `${strings.navigation.manageNurseReq}?activeList=upcoming`;
        return { path: url };
      }
      if (status === "SCHEDULED") {
        const url = requestId
          ? `${strings.navigation.viewSessionDetails}?requestId=${encodeURIComponent(requestId)}&from=scheduled`
          : `${strings.navigation.manageNurseReq}?activeList=scheduled`;
        return { path: url };
      }
      if (status === "VERIFIED") {
        const url = requestId
          ? `${strings.navigation.viewApprovedRequestDetails}?id=${encodeURIComponent(requestId)}&from=approved`
          : `${strings.navigation.manageNurseReq}?activeList=approved`;
        return { path: url };
      }
      // Default: go to new tab with request details
      const url = requestId
        ? `${strings.navigation.viewNurseReqDetails}?id=${encodeURIComponent(requestId)}`
        : `${strings.navigation.manageNurseReq}?activeList=new`;
      return { path: url };
    }

    return null;
  };

  const handleReadNoti = (notification) => {
    const userId = notification._id;
    const navData = notification.data;
    setReadId(userId);
    const target = getNotificationNavTarget(navData);
    if (target) {
      navigate(target.path, target.state ? { state: target.state, replace: true } : {});
    }
    setShowNotification(false);
    if (!notification.isRead) {
      dispatch(readNotification({ userId }));
    }
  };
  const groupNotificationsByDate = (notifications) => {
    const grouped = {};

    notifications.forEach((notification) => {
      const notificationDate = moment(notification.sentAt).format("DD/MM/YYYY");
      const today = moment().format("DD/MM/YYYY");
      const yesterday = moment().subtract(1, "days").format("DD/MM/YYYY");

      let dateKey = notificationDate;

      if (notificationDate === today) {
        dateKey = "Today";
      } else if (notificationDate === yesterday) {
        dateKey = "Yesterday";
      }

      if (!grouped[dateKey]) {
        grouped[dateKey] = [];
      }

      grouped[dateKey].push(notification);
    });

    return grouped;
  };
  const handleChromeNotClick = (notification) => {
    const target = getNotificationNavTarget(notification);
    if (target) {
      navigate(target.path, target.state ? { state: target.state, replace: true } : {});
    }
  };

  return (
    <div className="header">
      <div className="login-profile">
        <img className="profile-image" src={Icons.noProfile} alt="Profile" shape="circle" size="large" />

        <div className="profile-info">
          <span className="profile-name">{adminName}</span>
          {/* <span className="profile-role">Super Admin</span> */}
        </div>

        <div className="header-notification" ref={modalRef}>
          <div
            onClick={() => {
              setShowNotification(!showNotification);
              setNote(groupNotificationsByDate(notifications));
            }}
            className="notifcation"
          >
            {privilege.hasPatientProfileRight && notificationCount > 0 && <div className="noti-counter">{notificationCount > 99 ? "99+" : notificationCount}</div>}
            <img src={NotificationIcon} alt="icon" className="noti-icon" />
          </div>
          {showNotification && (
            <div className="notification-box">
              <div className="noti-head">{t("notifications")}</div>
              {privilege.hasPatientProfileRight ? (
                <div className="noti-scroll">
                  <div className="noti-container">
                    {Object.keys(note).map((dateKey) => (
                      <div key={dateKey}>
                        <div>
                          <div
                            className="noti-heading"
                            style={{
                              width: "max-content",
                              fontSize: "14px",
                              color: "#787878",
                              borderRadius: "5px",
                              display: "flex",
                              padding: "5px",
                              justifyItems: "center",
                            }}
                          >
                            {t(dateKey)}
                          </div>
                        </div>

                        {note[dateKey]
                          .sort((a, b) => new Date(b.sentAt) - new Date(a.sentAt))
                          .map((notification) => (
                            <div key={notification._id} className="notification-item" onClick={() => handleReadNoti(notification)}>
                              <div className="notif-profile">
                                <img src={Profile} alt="profile" className="profile-pic-noti" />
                              </div>
                              <div className="noti-details">
                                <div className={`noti-heading ${notification.isRead ? "noti-read" : "unread-head"}`}>{notification.title}</div>
                                <div className="noti-body">{notification.body}</div>
                              </div>
                              <div className="noti-time">
                                <div>{moment(notification.sentAt).format("hh:mm A")}</div>

                                <div className={`${notification.isRead ? "" : "noti-unread"}`}></div>
                              </div>
                            </div>
                          ))}
                      </div>
                    ))}
                  </div>
                  {hasMore &&
                    (loading ? (
                      <div className="load-more-container">
                        <div className="load-more-btn">{t("loading")}</div>
                      </div>
                    ) : (
                      <div
                        className="load-more-container"
                        onClick={() => {
                          handleLoadMore();
                        }}
                      >
                        <div className="load-more-btn">{t("loadMore")}</div>
                      </div>
                    ))}
                </div>
              ) : (
                <div className="noti-scroll">
                  <div className="noti-container unauth">{t("unauthAccess")}</div>
                </div>
              )}
            </div>
          )}
        </div>

        <Widgets.LanguageSwitcher />
        <section ref={logoutRef}>
          <FaEllipsisV className="vertical-dots" onClick={() => setShowMenu(!showMenu)} />

          {showMenu && (
            <div className="dropdown-menu">
              <div className="logout-link" onClick={handleLogout}>
                <span>{t("logout")}</span>
              </div>
            </div>
          )}
        </section>
      </div>
      <Widgets.ConfirmModal showModal={logoutPopup} handleCancel={handleCancelDelete} handleConfirm={handleConfirmDelete} heading="logout" description="logoutConfrim" />
    </div>
  );
};

export default Header;
